import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface SegmentedOption {
  value: string;
  label: string;
  /** Optional Material Symbols icon name shown before the label. */
  icon?: string;
}

@Component({
  selector: 'app-segmented-control',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './segmented-control.component.html',
  styleUrl: './segmented-control.component.css'
})
export class SegmentedControlComponent {
  @Input() options: SegmentedOption[] = [];
  @Input() selectedValue: string = '';
  @Output() valueChange = new EventEmitter<string>();

  selectOption(value: string) {
    if (this.selectedValue !== value) {
      this.selectedValue = value;
      this.valueChange.emit(value);
    }
  }

  isSelected(value: string): boolean {
    return this.selectedValue === value;
  }

  getSlidePosition(): number {
    const selectedIndex = this.options.findIndex(opt => opt.value === this.selectedValue);
    return selectedIndex >= 0 ? selectedIndex * 100 : 0;
  }

  getSegmentWidth(): number {
    return this.options.length > 0 ? 100 / this.options.length : 100;
  }

  getSelectedIndex(): number {
    const i = this.options.findIndex(opt => opt.value === this.selectedValue);
    return i >= 0 ? i : 0;
  }
}
